// extracted by mini-css-extract-plugin
export default {"header":"Table_header__dLCq+","link":"Table_link__Lhx8g","active":"Table_active__8w6qF","inactive":"Table_inactive__k1ZNw"};